module.exports = __webpack_public_path__ + "img/3d-painting_en.b80a3eb.jpg";